<div class="permissions">
  <kendo-expansionpanel [title]="'step.form.permissions.title' | i18n"
  [subtitle]="'step.form.permissions.subtitle' | i18n" [expanded]="false">
    <kendo-formfield [formGroup]="form" showHint="initial">
      <kendo-label [for]="canAddDocuments" [text]="'step.form.permissions.canAddDocuments.title' | i18n"></kendo-label>
      <kendo-switch
        #canAddDocuments
        [formControlName]="'canAddDocuments'"
        [onLabel]="'step.form.permissions.canAddDocuments.onLabel' | i18n"
        [offLabel]="'step.form.permissions.canAddDocuments.offLabel' | i18n"
        ></kendo-switch>
        <kendo-formhint><div>{{ 'step.form.permissions.canAddDocuments.hint' | i18n }}</div></kendo-formhint>
    </kendo-formfield>
  </kendo-expansionpanel>
</div>
